var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"login"}},[_c('div',{staticClass:"loginContainer"},[_vm._v(" "+_vm._s(_vm.acc)+" ")]),_c('div',{staticClass:"loginBackgroundM"})])}
var staticRenderFns = []

export { render, staticRenderFns }